import React, { useState } from "react";
import "./Contact.css";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    inquiryType: 'general',
    message: '',
    preferredContact: 'email',
    urgency: 'normal'
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the data to your backend
    console.log('Contact form submitted:', formData);
    setIsSubmitted(true);
  };

  if (isSubmitted) {
    return (
      <div className="contact-container">
        <div className="container">
          <div className="success-message">
            <div className="success-icon">📧</div>
            <h2>Message Sent Successfully!</h2>
            <p>Thank you for contacting Pandemic Relief Connect. We've received your message and will get back to you within 24 hours.</p>
            <div className="success-details">
              <h4>What happens next?</h4>
              <ul>
                <li>Our team will review your inquiry</li>
                <li>You'll receive a confirmation email shortly</li>
                <li>We'll respond via your preferred contact method</li>
                <li>For urgent matters, we'll prioritize your request</li>
              </ul>
            </div>
            <button 
              className="btn btn-primary"
              onClick={() => {
                setIsSubmitted(false);
                setFormData({
                  name: '',
                  email: '',
                  phone: '',
                  subject: '',
                  inquiryType: 'general',
                  message: '',
                  preferredContact: 'email',
                  urgency: 'normal'
                });
              }}
            >
              Send Another Message
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-container">
      <div className="container">
        <div className="contact-header">
          <h1>Contact Us</h1>
          <p>Get in touch with our team for support, partnerships, or general inquiries</p>
        </div>

        <div className="contact-content">
          {/* Contact Information */}
          <div className="contact-info">
            <h3>Get In Touch</h3>
            <div className="contact-methods">
              <div className="contact-method">
                <div className="method-icon">📧</div>
                <div className="method-details">
                  <h4>Email</h4>
                  <p>support@pandemicreliefconnect.org</p>
                  <span>Response within 24 hours</span>
                </div>
              </div>

              <div className="contact-method">
                <div className="method-icon">📞</div>
                <div className="method-details">
                  <h4>Phone</h4>
                  <p>(555) 123-HELP (4357)</p>
                  <span>Mon-Fri, 9AM-6PM EST</span>
                </div>
              </div>

              <div className="contact-method">
                <div className="method-icon">💬</div>
                <div className="method-details">
                  <h4>Live Chat</h4>
                  <p>Available on our website</p>
                  <span>Mon-Fri, 9AM-6PM EST</span>
                </div>
              </div>

              <div className="contact-method">
                <div className="method-icon">🏢</div>
                <div className="method-details">
                  <h4>Office</h4>
                  <p>123 Relief Street<br />Community City, CC 12345</p>
                  <span>By appointment only</span>
                </div>
              </div>
            </div>

            <div className="emergency-notice">
              <h4>🚨 Emergency Situations</h4>
              <p>For immediate emergency assistance, please contact your local emergency services (911) or relevant crisis hotlines. Our platform is designed for non-emergency relief coordination.</p>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-section">
            <h3>Send Us a Message</h3>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter your full name"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    placeholder="your.email@example.com"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="(555) 123-4567"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="inquiryType">Inquiry Type</label>
                  <select
                    id="inquiryType"
                    name="inquiryType"
                    value={formData.inquiryType}
                    onChange={handleInputChange}
                  >
                    <option value="general">General Inquiry</option>
                    <option value="donation">Donation Support</option>
                    <option value="volunteer">Volunteer Opportunities</option>
                    <option value="partnership">Partnership</option>
                    <option value="technical">Technical Support</option>
                    <option value="media">Media Inquiry</option>
                    <option value="feedback">Feedback</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  required
                  placeholder="Brief description of your inquiry"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  rows="6"
                  placeholder="Please provide details about your inquiry, question, or how we can help you..."
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="preferredContact">Preferred Contact Method</label>
                  <select
                    id="preferredContact"
                    name="preferredContact"
                    value={formData.preferredContact}
                    onChange={handleInputChange}
                  >
                    <option value="email">Email</option>
                    <option value="phone">Phone</option>
                    <option value="text">Text Message</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="urgency">Urgency Level</label>
                  <select
                    id="urgency"
                    name="urgency"
                    value={formData.urgency}
                    onChange={handleInputChange}
                  >
                    <option value="normal">Normal</option>
                    <option value="high">High Priority</option>
                    <option value="urgent">Urgent</option>
                  </select>
                </div>
              </div>

              <button type="submit" className="btn btn-primary submit-btn">
                Send Message
              </button>
            </form>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="faq-section">
          <h3>Frequently Asked Questions</h3>
          <div className="faq-grid">
            <div className="faq-item">
              <h4>How do I donate items?</h4>
              <p>Visit our Donate page to fill out the donation form. We'll coordinate pickup and ensure your items reach those in need.</p>
            </div>
            
            <div className="faq-item">
              <h4>Can I volunteer with your organization?</h4>
              <p>Yes! We welcome volunteers. Contact us with "Volunteer Opportunities" as your inquiry type to learn about current needs.</p>
            </div>
            
            <div className="faq-item">
              <h4>How do you ensure donations reach the right people?</h4>
              <p>We work with verified local organizations and maintain transparent tracking of all donations from pickup to distribution.</p>
            </div>
            
            <div className="faq-item">
              <h4>Is there a fee for using your platform?</h4>
              <p>No, our platform is completely free for both donors and recipients. We're funded through grants and partnerships.</p>
            </div>
            
            <div className="faq-item">
              <h4>What areas do you serve?</h4>
              <p>We're currently expanding our coverage. Contact us to check if we serve your area or to help us expand to your community.</p>
            </div>
            
            <div className="faq-item">
              <h4>How can my organization partner with you?</h4>
              <p>We're always looking for partnerships with local organizations, businesses, and community groups. Select "Partnership" in your inquiry.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}